import { render } from "./WCModalRoot.vue?vue&type=template&id=e24c618c&scoped=true"
import script from "./WCModalRoot.vue?vue&type=script&lang=js"
export * from "./WCModalRoot.vue?vue&type=script&lang=js"

import "./WCModalRoot.vue?vue&type=style&index=0&id=e24c618c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24c618c"]])

export default __exports__